import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, Box } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Button } from '@mui/material';
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import { useWaiverTemplates } from '../../../hooks/waivers/useWaiverTemplates';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import { useTranslation } from 'react-i18next';
import { truncateString } from '../../../utils/truncateString';
import LoadingSpinner from '../../common/controls/LoadingSpinner';
import WaiverTemplateForm from '../forms/WaiverTemplateForm';
import { useDeleteWaiverTemplate } from '../../../hooks/waivers/useDeletWaiverTemplate';
import { useSnackbar } from '../../../context/SnackbarContext';
import DefaultWaiverTemplatesSeederDialog from '../forms/DefaultWaiverTemplatesSeederDialog';
import RequirePermission from '../../RequirePermission';
import { userHasAccess } from '../../../utils/userHasAccess';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function WaiverTemplates() {

    const { t } = useTranslation('common');
    const { showSnackbar } = useSnackbar();

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };
    const [listTrigger, setListTrigger] = React.useState(false);
    const toggleListTrigger = () => {
        setListTrigger(prev => !prev);
    };

    const onEmptyData = () => {
        setSeederDialogOpen(true);
    };

    const { waiverTemplates, loading, setWaiverTemplates } = useWaiverTemplates(listTrigger, onEmptyData);

    const { remove } = useDeleteWaiverTemplate(toggleListTrigger);

    const [selectedWaiverTemplate, setSelectedWaiverTemplate] = useState();

    const [formOpen, setFormOpen] = React.useState(false);
    const [formMode, setFormMode] = React.useState("create");
    const [seederDialogOpen, setSeederDialogOpen] =  React.useState(false);

    const handleAdd = () => {
        setSelectedWaiverTemplate(null);
        setFormMode("create");
        setFormOpen(true);
    };

    const handleEdit = (waiverTemplate) => {
        setSelectedWaiverTemplate(waiverTemplate);
        setFormMode("edit");
        setFormOpen(true);
    };

    const onSaveSuccess = () => {
        toggleListTrigger();
        setFormOpen(false);
    };

    const handleDelete = async (waiverTemplate) => {
        try {
            await remove(waiverTemplate.id);
            showSnackbar(t('waivers.templates.messages.delete_success', { name: waiverTemplate.name }), "success");
        } catch (err) {
          showSnackbar(t('waivers.templates.messages.delete_fail', { name: waiverTemplate.name }), "error");
        }
    };

    return (
        <>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <EditDocumentIcon fontSize='large' color='secondary' />
            </ListItemIcon>
            <ListItemText 
                primary="Waiver Templates"
                secondary="view and manage waiver templates"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>

            <DialogTitle>
                Waiver Templates
            </DialogTitle>
            <DialogContent>
                <List>
                {loading ? (
                    <ListItem>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <LoadingSpinner />
                    </Box>
                    </ListItem>
                ) : (
                    waiverTemplates?.map((waiverTemplate) => (
                    <ListItem
                        key={waiverTemplate.id}
                        secondaryAction={
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <VerticalHamburgerMenu
                            options={[
                                { 
                                id: 1, 
                                name: 'Edit',
                                callback: () => handleEdit(waiverTemplate),
                                disabled: !userHasAccess(SUB_MODULES.WAIVER_TEMPLATES, 2)
                                },
                                // {
                                // id: 2,
                                // name: 'Delete',
                                // callback: () => handleDelete(waiverTemplate),
                                // confirmMessage: t('waivers.templates.messages.delete_confirm', { name: waiverTemplate.name }),
                                // disabled: !userHasAccess(SUB_MODULES.WAIVER_TEMPLATES, 3)
                                // },
                            ]}
                            />
                        </Box>
                        }
                    >
                        <ListItemButton onClick={() => handleEdit(waiverTemplate)}>
                        <ListItemText
                            primary={waiverTemplate.name}
                        />
                        </ListItemButton>
                    </ListItem>
                    ))
                )}
                </List>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        <WaiverTemplateForm 
            successCallback={onSaveSuccess}
            waiverTemplate={selectedWaiverTemplate}
            mode={formMode}
            open={formOpen}
            onClose={() => setFormOpen(false)}
        />
        <DefaultWaiverTemplatesSeederDialog
            open={seederDialogOpen}
            setOpen={setSeederDialogOpen} 
            successCallback={toggleListTrigger}
        />
        </>
    );
}